import { createReducer } from 'helpers/redux';

export const namespace = 'snackbar';

const SHOW_SNACKBAR = 'vtn/snackbar/SHOW_SNACKBAR';
const HIDE_SNACKBAR = 'vtn/snackbar/HIDE_SNACKBAR';

const SHOW_DIALOG = 'vtn/snackbar/SHOW_DIALOG';
const HIDE_DIALOG = 'vtn/snackbar/HIDE_DIALOG';

const SHOW_SNACKBAR_WITH_ACTION = 'vtn/snackbar/SHOW_SNACKBAR_WITH_ACTION';
const HIDE_SNACKBAR_WITH_ACTION = 'vtn/snackbar/HIDE_SNACKBAR_WITH_ACTION';

const defaultState = {
  snackbar: {
    open: false,
    message: ''
  },
  dialog: {
    open: false,
    message: '',
    title: ''
  },
  snackbarWithAction: {
    open: false,
    action: ''
  }
};

const reducer = createReducer(defaultState, {
  [SHOW_SNACKBAR](state, action) {
    if (!action.payload.message) {
      return {
        ...state
      };
    }

    return {
      ...state,
      snackbar: {
        open: true,
        message: action.payload.message
      }
    };
  },
  [HIDE_SNACKBAR](state) {
    return {
      ...state,
      snackbar: defaultState.snackbar
    };
  },
  [SHOW_DIALOG](state, action) {
    return {
      ...state,
      dialog: {
        open: true,
        title: action.payload.title,
        message: action.payload.message
      }
    };
  },
  [HIDE_DIALOG](state) {
    return {
      ...state,
      dialog: defaultState.dialog
    };
  },
  [SHOW_SNACKBAR_WITH_ACTION](state, action) {
    return {
      ...state,
      snackbarWithAction: {
        open: true,
        action: action.payload.action
      }
    };
  },
  [HIDE_SNACKBAR_WITH_ACTION](state) {
    return {
      ...state,
      snackbarWithAction: defaultState.snackbarWithAction
    };
  }
});

export default reducer;

function local(state) {
  return state[namespace];
}

export function showNotification(message) {
  return {
    type: SHOW_SNACKBAR,
    payload: {
      message
    }
  };
}

export function hideSnackbarNotification() {
  return {
    type: HIDE_SNACKBAR
  };
}

export function showDialogNotification(title, message) {
  return {
    type: SHOW_DIALOG,
    payload: {
      title,
      message
    }
  };
}

export function hideDialogNotification() {
  return {
    type: HIDE_DIALOG
  };
}

export function showSnackbarWithAction(action) {
  return {
    type: SHOW_SNACKBAR_WITH_ACTION,
    payload: {
      action
    }
  };
}

export function hideSnackbarWithAction() {
  return {
    type: HIDE_SNACKBAR_WITH_ACTION
  };
}

export function selectSnackbarNotificationState(state) {
  return local(state).snackbar;
}

export function selectDialogNotificationState(state) {
  return local(state).dialog;
}

export function selectSnackbarWithActionState(state) {
  return local(state).snackbarWithAction;
}



// WEBPACK FOOTER //
// ./src/client/modules/snackbar.js